import { HomeInteractive } from '../../interfaces'
import { SyntheticEvent } from 'react'

type IAttribute = {
  attributes: any
}

export type Policies = {
  policy_iframe: IAttribute
}

export const policiesInteractive: HomeInteractive<Policies> = () => ({
  policy_iframe: {
    attributes: {
      onLoad: (event: SyntheticEvent<HTMLIFrameElement, Event>) => {
        const iframeElement = event.currentTarget

        if (!iframeElement?.contentDocument?.documentElement) {
          return
        }

        iframeElement.contentDocument.documentElement.style.height =
          'fit-content'

        iframeElement.height =
          iframeElement.contentDocument.documentElement.scrollHeight + 'px'

        iframeElement.style.minHeight = '0'

        const resizeObserver = new ResizeObserver((entries) => {
          iframeElement.height = entries[0].contentRect.height + 'px'
        })

        resizeObserver.observe(iframeElement.contentDocument.documentElement)

        iframeElement.contentDocument
          .querySelectorAll('a')
          .forEach((element) => {
            try {
              const url = new URL(element.href)

              if (url.hash) {
                element.addEventListener('click', (event) => {
                  event.preventDefault()
                  const id = url.hash.replace('#', '')

                  const elementToScroll =
                    iframeElement.contentDocument.getElementById(id)

                  if (elementToScroll) {
                    elementToScroll.scrollIntoView()
                  }
                })
              } else {
                element.target = url.href.startsWith('http')
                  ? '_blank'
                  : '_parent'
              }
            } catch (error) {
              element.target = '_parent'
            }
          })
      },
    },
  },
})
